
import {AdminStore} from '../config/store';

export const localStorageMiddleware = (store: AdminStore) => {
    localStorage.setItem('editOrder', JSON.stringify(store.editOrder));
}


